/* eslint-disable no-console, no-empty */
// instrument.js - Global Console & Network Diagnostics Interceptor

const MAX_CONSOLE_LOGS = 50;
const MAX_NETWORK_LOGS = 25;

const consoleLogsBuffer = [];
const networkLogsBuffer = [];

let isInitialized = false;

export const initInstrumentation = () => {
  if (isInitialized) return;
  isInitialized = true;

  // 1. Intercept console logs
  const originalLog = console.log;
  const originalWarn = console.warn;
  const originalError = console.error;

  const pushLog = (type, args) => {
    try {
      const message = args
        .map((arg) => (typeof arg === "object" ? JSON.stringify(arg) : String(arg)))
        .join(" ");

      consoleLogsBuffer.push({
        type,
        message: message.slice(0, 500),
        time: new Date().toLocaleTimeString(),
      });

      if (consoleLogsBuffer.length > MAX_CONSOLE_LOGS) {
        consoleLogsBuffer.shift();
      }
    } catch (_) {}
  };

  console.log = (...args) => {
    pushLog("log", args);
    originalLog.apply(console, args);
  };

  console.warn = (...args) => {
    pushLog("warn", args);
    originalWarn.apply(console, args);
  };

  console.error = (...args) => {
    pushLog("error", args);
    originalError.apply(console, args);
  };

  // 2. Intercept window error events
  window.addEventListener("error", (event) => {
    pushLog("error", [event.message || "Uncaught Error"]);
  });

  window.addEventListener("unhandledrejection", (event) => {
    pushLog("error", [`Unhandled Rejection: ${event.reason}`]);
  });

  // 3. Intercept Fetch API
  const originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = async (...args) => {
      const startTime = Date.now();
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "unknown";
      const method = args[1]?.method || "GET";

      try {
        const response = await originalFetch(...args);
        const duration = Date.now() - startTime;

        networkLogsBuffer.push({
          method,
          url: url.split("?")[0],
          status: response.status,
          duration: `${duration}ms`,
          time: new Date().toLocaleTimeString(),
        });

        if (networkLogsBuffer.length > MAX_NETWORK_LOGS) {
          networkLogsBuffer.shift();
        }

        return response;
      } catch (err) {
        const duration = Date.now() - startTime;
        networkLogsBuffer.push({
          method,
          url: url.split("?")[0],
          status: "ERR_FAILED",
          duration: `${duration}ms`,
          time: new Date().toLocaleTimeString(),
        });
        if (networkLogsBuffer.length > MAX_NETWORK_LOGS) {
          networkLogsBuffer.shift();
        }
        throw err;
      }
    };
  }
};

export const getDiagnosticsData = () => {
  return {
    consoleLogs: [...consoleLogsBuffer],
    networkLogs: [...networkLogsBuffer],
  };
};
